import { render, staticRenderFns } from "./PbAlert.vue?vue&type=template&id=92fb4bda&"
import script from "./PbAlert.vue?vue&type=script&lang=js&"
export * from "./PbAlert.vue?vue&type=script&lang=js&"
import style0 from "./PbAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports